import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom"
import MicroModal from "micromodal";
import ModalAlertas from '../components/ModalAlertas';
import { store, GENERAL_URL_API } from '../components/Store.js';
import postAjax from '../js/utilities/postAjax';
import getAjax from "../js/utilities/getAjax";
import getUrlParam from '../js/utilities/getUrl';
import useObtenerSubsecciones from '../js/translations/useObtenerSubsecciones';
import { InstitucionesForm } from "./instituciones-form";
import { useQueryParams } from "../hooks/useQueryParams";

/**
 * Este formulario no recibe Props. Este se encarga de renderizar la pantalla de login. Sus principales funciones son validar la información de formulario de Inicio de sesión y redireccionar a la pantalla indicada, actualizar la información de la sesión activa en el localStorage y validar los campos del formulario ¿tu institucion ya tiene MakeMake? y posterior a esto redireccionar al formulario adecuado. Este hace uso de los componentes ModalAlertas y InstitucionesForm.
 * @returns Login
 */
const Login = () => {
  const { isReady, textosSubSecciones: textosLogin } = useObtenerSubsecciones('login');
  const [message, setMessage] = useState('');
  const [description, setDescription] = useState('');
  const [messageLogin, setMessageLogin] = useState('');
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const [sendingLogin, setSendingLogin] = useState(false);
  const userName = useRef(null);
  const password = useRef(null);
  const loginForm = useRef(null);
  const history = useHistory();
  const params = useQueryParams();

  useEffect(()=>{
   enviarUrl();
  },[state?.sesionActiva])

  useEffect(() => {
    let ezproxy = '';
    if (typeof getUrlParam("ezproxy") !== "undefined") {
      ezproxy = decodeURIComponent(getUrlParam("ezproxy")).replace(/\+/g, " ");
      if (ezproxy !== '') {
        postAjax(`${GENERAL_URL_API}/assets/ezLogin`, { 'ip': ezproxy }, response => {
          if (response.includes('Exito')) {
            getAjax(`${GENERAL_URL_API}/assets/datosHeader`, {}, response => {
              let makemakeData = JSON.parse(response).makemakeData;
              let categoriasMenu = JSON.parse(response).categoriasMenu;
              window.localStorage.setItem('makemakeData', JSON.stringify(makemakeData))
              window.localStorage.setItem('categoriasMenu', JSON.stringify(categoriasMenu))
              dispatch({ type: 'CHANGE_VALUE', property: 'pais', value: makemakeData.pais })
              dispatch({ type: 'CHANGE_VALUE', property: 'sesionActiva', value: makemakeData.sesionActiva })
              dispatch({ type: 'CHANGE_VALUE', property: 'userType', value: makemakeData.userType })
              dispatch({ type: 'CHANGE_VALUE', property: 'username', value: makemakeData.username })
              dispatch({ type: 'CHANGE_VALUE', property: 'datosHeader', value: makemakeData.datosHeader })
              dispatch({ type: 'CHANGE_VALUE', property: 'categoriasMenu', value: categoriasMenu })
              dispatch({ type: 'CHANGE_VALUE', property: 'tipo', value: makemakeData?.tipo })
              enviarUrl()
            })
          }

        })
      }
    }
  }, [])

  /**
   * Esta función sirve para direccionar el sitio una vez se ha iniciado sesión
   */
  const enviarUrl = () => {
    const bookUrl = params.get('bookT');
    if (state?.sesionActiva === 'SI') {
      if (params.has('bookT')) {
        history.push(bookUrl)
      } else {
        history.push('/')
      }
    }

  }

  /**
   * Esta función genera una lista de características del login Bibliotecas
   * @returns {Array<li>} - Arreglo de los elementos de la lista. 
   */
  const infoBibliotecas = () => {
    const puntos = [];
    if (isReady) {
      const textoPuntos = textosLogin.info_login;
      Object.keys(textoPuntos).map((item, index) => {
        puntos.push(
          <li key={`bibliotecas${index}`} className="mt-3" dangerouslySetInnerHTML={{ __html: textoPuntos[item] }}></li>
        )
      })
    }
    return puntos;
  }

  /**
   * Esta función se encarga de validar el campo de ¿tu institucion ya tiene MakeMake? y posterior a esto redireccionar al formulario adecuado.
   * @param {string} institucion 
   */
  const institucionHandler = (institucion) => {
    if (institucion !== 'no-encontrado') {
      history.push({
        pathname: '/informacion/ingresar-correo',
        search: `?it=${decodeURIComponent(institucion)}`
      });

    } else {
      history.push('/compra/informacion-institucional');
    }
  }

  return (
    <>
      {
        isReady &&
        <div className="pb-5 logins login-bibliotecas-page ">
          <div className="container px-0">
            <div className="row mx-0 pt-5">
              <section className="col-lg-6 order-lg-2 px-2 px-lg-0">
                <div className="caja mx-auto">
                  <h2 className="mb-4 section-title font-weigth-bold">{textosLogin?.titulos?.iniciar || 'Iniciar sesión'}</h2>

                  <div className="pl-selectuser px-lg-5 px-3 pt-5">
                    <strong>
                      {
                        (() => {
                          if (messageLogin !== '') {
                            return (
                              <p className="text-center mb-3 primary-item" id="error-message" role={'alert'} aria-live={'assertive'}>{messageLogin}</p>
                            )
                          }
                        })()
                      }
                    </strong>

                    <form ref={loginForm} id="loginctfId" name="loginctf" className="mm-redimir_createaccount" method="post">
                      <p className="secondary-item " aria-hidden={true}>{textosLogin?.input_usuario?.usuario?.texto || 'Usuario:'}</p>
                      <label
                        htmlFor="inputUser"
                        className="sr-only"
                      >{textosLogin?.input_usuario?.usuario?.label || 'Nombre de usuario'}</label>
                      <input
                        ref={userName}
                        onClick={() => { setMessageLogin('') }}
                        autoComplete="username"
                        type="text"
                        className="form-control mb-3 surface--bg  onbackground-third--color focusable-secondary"
                        id="inputUser"
                        placeholder={textosLogin?.input_usuario?.usuario?.placeholder || "Escribe tu nombre de usuario"}
                        name="user"
                        required
                      />

                      <p className="secondary-item " aria-hidden={true}>{textosLogin?.input_usuario?.contrasenia?.texto || 'Contraseña:'}</p>
                      <label
                        htmlFor="inputPassword"
                        className="sr-only"
                      >{textosLogin?.input_usuario?.contrasenia?.label || 'Contraseña'}</label>
                      <input
                        ref={password}
                        autoComplete="off"
                        type="password"
                        className="form-control surface--bg  onbackground-third--color focusable-secondary"
                        id="inputPassword"
                        placeholder={textosLogin?.input_usuario?.contrasenia?.placeholder || "Escribe tu contraseña"}
                        name="password"
                        required
                      />

                      <div className="row mx-0 justify-content-end">
                        <div className="col-lg-6 mt-5 mb-4 mx-0 p-0 pl-lg-3 pr-lg-0">
                          <button className="btn btn-primary d-block col-12 btn-iniciar-sesion focusable-red"
                            onClick={e => {

                              if (loginForm.current.checkValidity()) {
                                e.preventDefault();
                                setSendingLogin(true);
                                postAjax(`${GENERAL_URL_API}/assets/login`, { 'username': userName.current.value, 'password': password.current.value }, response => {
                                  if (response.includes('Exito')) {
                                    getAjax(`${GENERAL_URL_API}/assets/datosHeader`, {}, response => {
                                      let makemakeData = JSON.parse(response).makemakeData;
                                      let categoriasMenu = JSON.parse(response).categoriasMenu;
                                      window.localStorage.setItem('makemakeData', JSON.stringify(makemakeData))
                                      window.localStorage.setItem('categoriasMenu', JSON.stringify(categoriasMenu))
                                      dispatch({ type: 'CHANGE_VALUE', property: 'pais', value: makemakeData.pais })
                                      dispatch({ type: 'CHANGE_VALUE', property: 'sesionActiva', value: makemakeData.sesionActiva })
                                      dispatch({ type: 'CHANGE_VALUE', property: 'userType', value: makemakeData.userType })
                                      dispatch({ type: 'CHANGE_VALUE', property: 'username', value: makemakeData.username })
                                      dispatch({ type: 'CHANGE_VALUE', property: 'datosHeader', value: makemakeData.datosHeader })
                                      dispatch({ type: 'CHANGE_VALUE', property: 'categoriasMenu', value: categoriasMenu })
                                      dispatch({ type: 'CHANGE_VALUE', property: 'tipo', value: makemakeData?.tipo })
                                      setSendingLogin(false);
                                      enviarUrl()
                                    })
                                  } else {
                                    setSendingLogin(false);
                                    if (response.includes('Error, usuario o contraseña')) {
                                      setMessageLogin(textosLogin?.mensaje_alerta?.login || 'Has ingresado un nombre de usuario o contraseña incorrecto. Intenta otra vez.')
                                    } else if (response.includes('Error, concurrencias copadas')) {
                                      try {
                                        MicroModal.show('modal-alertas-autenticacion', {
                                          awaitCloseAnimation: true
                                        });
                                      }
                                      catch (error) {
                                        console.log('modal alertas error', error)
                                      }
                                      setMessage(textosLogin?.mensaje_alerta?.limite?.mensaje || 'Has superado el límite de concurrencias');
                                      setDescription(textosLogin?.mensaje_alerta?.limite?.descripcion || 'En este momento tienes más usuarios conectados de los que admite tu suscripción. Comunícate con ventas para aumentar la capacidad de usuarios simultáneos. Escríbenos a contacto@makemake.com.co');
                                    } else if (response.includes('Error, suscripcion caducada')) {
                                      try {
                                        MicroModal.show('modal-alertas-autenticacion', {
                                          awaitCloseAnimation: true
                                        });
                                      }
                                      catch (error) {
                                        console.log('modal alertas error', error)
                                      }

                                      setMessage(textosLogin?.mensaje_alerta?.caducado?.mensaje || 'Tu suscripción ha caducado');
                                      setDescription(textosLogin?.mensaje_alerta?.caducado?.descripcion || 'Comunícate con ventas para renovar el período de la suscripción o escríbenos a contacto@makemake.com.co');
                                    } else {
                                      console.error(response);
                                    }
                                  }

                                })
                              }
                            }}
                          >
                            {(() => {
                              if (sendingLogin) {
                                return (
                                  <i className="fas fa-spinner fa-pulse"></i>
                                )
                              } else {
                                return textosLogin?.login?.botones?.iniciar_sesion || 'Iniciar sesión'
                              }
                            })()}

                          </button>
                        </div>
                      </div>
                    </form>

                    <hr className='onbackground-primary--color' aria-hidden={true} />

                    <InstitucionesForm onSubmit={(institucion) => institucionHandler(institucion)} />

                    <hr className='onbackground-primary--color' aria-hidden={true} />

                    <div className="row mx-0 pt-3 pb-4">
                      <h2 className="secondary-item">{textosLogin?.titulos?.no_tienes || '¿No tienes una cuenta?'}</h2>
                      <div className="col-lg-6 mt-3 mx-0 px-0 pl-lg-0 pr-lg-3 px-xl-0">
                        <Link to="/tienda" className="btn mm-demo d-block col-12 px-1 focusable-red">
                          {textosLogin?.login?.botones?.quiero || 'Quiero MakeMake'}
                        </Link>
                      </div>
                      <div className="col-lg-6 mt-3 mx-0 p-0 pl-lg-3 pr-lg-0">
                        <Link to="/codigo/redimir" className="btn btn-secondary d-block col-12 px-1 focusable-red">
                          {textosLogin?.login?.botones?.redimir || 'Redimir un código'}
                        </Link>
                      </div>
                    </div>

                    <hr className='onbackground-primary--color' aria-hidden={true} />

                    <div className="pt-3">
                      <h2 className="secondary-item">{textosLogin?.titulos?.otros_inicios || 'Otros inicios de sesión'}</h2>

                      <div className="row mx-0 pt-3 pb-5">
                        <div className="col-6 px-0">
                          <a href="http://makemake.com.co/planlector" className="otro-inicio img-plan mx-auto colegios d-block focusable-red">
                            <p className="text-center py-1 px-2">{textosLogin?.login?.botones?.colegios || 'Colegios'}</p>
                          </a>
                        </div>
                        <div className="col-6 px-0">
                          <a className="otro-inicio img-plan mx-auto academia d-block focusable-red" href="https://academia.makemake.com.co/login">
                            <p className="text-center py-1 px-2 ">{textosLogin?.login?.botones?.academia || 'Academia'}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="col-lg-6 order-lg-1 px-2 px-lg-3 px-xl-0">
                <div className="caja2 mx-auto">
                  <div className="img-plan mx-auto biblioteca mb-5 mt-5 mt-lg-0">
                    <p className="text-center py-1 px-3">{textosLogin?.login?.botones?.bibliotecas || 'Bibliotecas'}</p>
                  </div>

                  <ul className="circle-list px-4">
                    {infoBibliotecas()}
                  </ul>

                  <Link to="/que-es-bibliotecas" className="btn btn-primary mt-5 mx-auto d-block col-lg-5 btn-iniciar-sesion focusable-primary"> {textosLogin?.login?.botones?.conoce || 'Conoce más'}</Link>
                </div>
              </section>
            </div>
          </div>
        </div>
      }

      <ModalAlertas id={"modal-alertas-autenticacion"} message={message} description={description} />
    </>
  )
}

export default Login;